import React from 'react';
import { getHeaderAndParagraphCustomStylesWUT, useRicosTheme } from '../../../theme/ricos-theme-utils';
import RicosViewer from '../../../ui/ricos-viewer/ricos-viewer';
const RICOS_THEME = {
  customStyles: getHeaderAndParagraphCustomStylesWUT()
};
export const BookingsRichTextWUT = _ref => {
  let {
    content,
    id,
    FieldLayout
  } = _ref;
  const customTheme = useRicosTheme(RICOS_THEME);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id
  }, /*#__PURE__*/React.createElement(RicosViewer, {
    content: content,
    customTheme: customTheme
  }));
};
//# sourceMappingURL=bookings-rich-text-wut.js.map